import { formatDate } from "@/core/helpers/DatetimeConverter";

const PurchasesMap = {
  Plural: "Purchases",
  Single: "Purchase",
  ModalForm: false,
  DefaultSorting: "purchasedAt",
  DefaultSortingType: "desc",
  Columns: [
    { name: "", label: "#", type: "counter" },
    {
      name: "nickName",
      dbName: "user.nickName",
      label: "Nickname",
      type: "text",
      format: (row: any) => row.user?.nickName ?? "—",
    },
    {
      name: "email",
      dbName: "user.email",
      label: "Email",
      type: "text",
      format: (row: any) => row.user?.email ?? "—",
    },
    {
      name: "price",
      dbName: "price",
      label: "Price (€)",
      sortable: true,
      type: "text",
      format: (row: any) => (Number(row.price) || 0).toFixed(2),
    },
    {
      name: "purchasedAt",
      dbName: "purchasedAt",
      label: "Purchased at",
      sortable: true,
      type: "date",
      format: (row: any) => formatDate(row.purchasedAt),
    },
    {
      name: "expiresAt",
      dbName: "expiresAt",
      label: "Expires at",
      sortable: true,
      type: "date",
      format: (row: any) => (row.expiresAt ? formatDate(row.expiresAt) : "—"),
    },
  ],
  Filters: [
    {
      name: "Email",
      label: "Email",
      nameToRequest: "Email",
      type: "text",
      valueType: "text",
    },
  ],
  PrimaryKey: "id",
  Actions: {}, // no edit/delete actions
};

export default PurchasesMap;
